/**
 * Formatage des dates affichees.
 *
 * JJ/MM/AAAA, en fuseau local. Une date absente s'affiche comme absente :
 * aucune valeur de repli, aucun tiret decoratif qui ferait croire a une donnee.
 */
export function formaterDateFr(valeur: string | null | undefined): string {
  if (!valeur) return ''

  const date = new Date(valeur)
  if (Number.isNaN(date.getTime())) return ''

  const jour = String(date.getDate()).padStart(2, '0')
  const mois = String(date.getMonth() + 1).padStart(2, '0')
  return `${jour}/${mois}/${date.getFullYear()}`
}
